import { render, staticRenderFns } from "./SelfPublishingFlow.vue?vue&type=template&id=19f1cb4d&scoped=true&"
import script from "./SelfPublishingFlow.vue?vue&type=script&lang=js&"
export * from "./SelfPublishingFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f1cb4d",
  null
  
)

export default component.exports